import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CitySaintDenisPage() {
  const data = citiesData.find((c) => c.slug === "saint-denis")!;
  return <CityPage data={data} />;
}
